<div *ngIf="errorMessage" class="alert alert-danger" role="alert">
    <i class="far fa-exclamation-square me-2"></i>{{errorMessage}}
</div>
